import {E2EPage, newE2EPage} from '@stencil/core/testing';
import {Page as PuppeteerPage, Viewport} from 'puppeteer';
import {NewE2EPageOptions} from '@stencil/core/testing/puppeteer/puppeteer-declarations';

export type CustomE2EPage = E2EPage & Pick<PuppeteerPage, 'screenshot'>;

export async function createPage(opts?: NewE2EPageOptions, viewport: Viewport = {height: 600, width: 1000}) {
    const page = (await newE2EPage(opts)) as CustomE2EPage;
    await page.evaluateHandle(() => (document as any).fonts.ready);
    await page.setViewport(viewport);
    return page;
}

export async function createMobilePage(opts?: NewE2EPageOptions) {
    return createPage(opts, {height: 640, width: 320});
}

export async function setPageContent(page: CustomE2EPage, html: string) {
    await page.setContent(html);
    await page.addStyleTag({
        content: `
        :root {
            --joy-transition-duration-short: 0.01ms !important;    
            --joy-transition-duration-default: 0.01ms !important;    
            --joy-transition-duration-long: 0.01ms !important;    
        }
    `,
    });
    return page;
}
